export const GROUP = {
    TITLE: 'Grupos',
    GROUP_NAME_TITLE: 'Nombre del Grupo',
    GROUP_ID_PTX_TITLE: 'ID Ptx',
    GROUP_MOTORFY_ID: 'ID',
    GROUP_TYPE_TITLE: 'Tipo de grupo',
    GROUP_ASSOCIATE_MEMBERS_TITLE: 'Miembros asociados',
    GROUP_USERS_TITLE: 'Usuarios asociados',
    GROUP_WARRANTY_TITLE: 'Garantía',
    GROUP_WARRANTY_STATUS: 'Estado',
    GROUP_WARRANTY_PAYMENT_TYPE: 'Tipo de pago',
    GROUP_WARRANTY_BILLING_MAIL: 'Correo de facturación',
    GROUP_TYPE_HEADER: 'Pertenece a',
    INVENTORY: 'Inventario',
    GROUP_SUPERVISOR_TITLE: 'Supervisor comercial',
    GROUP_ADVISER_TITLE: 'Asesor asignado',
    GROUP_MARKET_NAME_TITLE: 'Mercado',
    GROUP_EXTERNAL_ADVISER_TITLE: 'Externo',
    GROUP_ADDRESS_TITLE: 'Dirección',
    GROUP_DOMICILE_POSTAL_CODE: 'Código Postal',
    GROUP_PHONE_WHATSAPP: 'Teléfono de Whatsapp',
    GROUP_DOMICILE_STATE: 'Estado',
    GROUP_DOMICILE_CITY: 'Ciudad',
    GROUP_DOMICILE_MUNICIPALITY: 'Delegación o Municipio',
    GROUP_DOMICILE_COLONY: 'Colonia',
    GROUP_CREDITS_TITLE: 'Créditos',
    GROUP_CREDITS_STATUS: 'Estado',
    GROUP_INSURANCE_STATUS: 'Estado',
    GROUP_QUOTE_STATUS: 'Estado',
    GROUP_PREMIUM_INVENTORY_STATUS: 'Estado',
    GROUP_BIOMETRICS_STATUS: 'Estado',
    GROUP_EXPRESS_PROFILER_STATUS: 'Estado',
    GROUP_APPROVALS_STATUS: 'Estado',
    GROUP_SCOTIA_PREMIUM_INVENTORY_STATUS: 'Estado',
    GROUP_INSURANCE_STATUS_TITLE: 'Seguros',
    GROUP_QUOTE_STATUS_TITLE: 'Cotizaciones',
    GROUP_PREMIUM_INVENTORY_STATUS_TITLE: 'Inventario Certificado',
    GROUP_BIOMETRICS_STATUS_TITLE: 'Biométricos',
    GROUP_EXPRESS_PROFILER_STATUS_TITLE: 'Perfilador Express',
    GROUP_APPROVALS_STATUS_TITLE: 'Aprobaciones',
    GROUP_CALCULATOR_PREMIUM_INVENTORY_TITLE: 'Calculadora Activada',
    GROUP_BANKS_TITLE: 'Entidades Financieras',
    GROUP_CHANNEL_TITLE: 'Canales',
    EDIT_GROUP: 'Editar Grupo',
    ADD_GROUP: 'Agregar Grupo',
    NEW_GROUP_ACTION: 'NEW',
    GROUP_MIGRATE_REQUESTS_TITLE: 'Migrar solicitudes asociadas',
    GROUP_MIGRATE_REQUESTS_ACTION: 'Migrar solicitudes',
    GROUP_ADD_ADDRESS: 'Ingrese una dirección',
    GROUP_DELETE_REQUESTS_ACTION: 'Eliminar grupo',
    GROUP_MIGRATE_REQUESTS_LABEL: 'Migrar solicitudes al grupo',
    GROUP_MIGRATE_REQUESTS_PLACEHOLDER: 'Selecciona el grupo a migrar',
    GROUP_CREDIT_NUMBER_TITLE: 'créditos',
    GROUP_WARRANTY_NUMBER_TITLE: 'garantías',
    GROUP_QUOTATION_NUMBER_TITLE: 'cotizaciones',
    GROUP_INSURANCE_NUMBER_TITLE: 'seguros',
    GROUP_PAYMENT_TYPE_PLACEHOLDER: 'Prepago',
    DELETE_GROUP_TITLE: '¿Deseas eliminar el Grupo?',
    MIGRATE_GROUP_TITLE: '¿Deseas migrar las solicitudes?',
    DELETE_CARD_COMMISSION_GROUP_TITLE: '¿Seguro deseas eliminar?',
    MIGRATE_GROUP_CANCEL_BUTON: 'Cancelar',
    DELETE_GROUP_CANCEL_BUTON: 'Cancelar',
    MIGRATE_GROUP_CONFIRM_BUTON: 'Sí, Migrar las solicitudes',
    DELETE_GROUP_CONFIRM_BUTON: 'Eliminar grupo',
    DELETE_CARD_COMMISSION_CONFIRM_BUTON: 'Eliminar tarjeta',
    MIGRATE_GROUP_FINISH_BUTON: 'Listo',
    MIGRATE_GROUP_SUCCESS_MESSAGE: '¡Migración exitosa!',
    GROUP_MOTORFY_LABEL: 'ID Motorfy:',
    GROUP_CREATED_AT: 'Creado el:',
    GROUP_FUNDING_TITLE: 'Fondeo',
    GROUP_ADD_BANK_ACCOUNT_TITLE: 'Agregar Cuenta',
    GROUP_ADD_CARD_COMMISSION_TITLE: 'Agregar Tarjeta',
    GROUP_ADD_CARD_COMMISSION_SUBTITLE: 'Tarjeta para pago de comisión',
    GROUP_ACCOUNTS_BANK_ACCOUNT_TITLE: 'Cuentas para desembolso:',
    GROUP_DETAIL_ACCOUNT_TITLE: 'Ver detalles de la cuenta',
    GROUP_DETAIL_CARD_COMMISSION_TITLE: 'Ver detalles de la tarjeta',
    GROUP_ACCOUNT_NUMBER_TITLE: 'No. Cuenta:',
    GROUP_ACCOUNT_NUMBER_FIELD_TITLE: 'Número de cuenta',
    GROUP_CARD_COMMISSION_ACCOUNT_NUMBER_FIELD_TITLE: 'Código de tarjeta',
    GROUP_BENEFICIARY_TITLE: 'Beneficiario',
    GROUP_BENEFICIARY_NAME_TITLE: 'Nombre del beneficiario',
    GROUP_CLABE_INTERBANK_TITLE: 'Clabe Interbancaria',
    GROUP_BANK_TITLE: 'Banco',
    GROUP_BANK_SANTANDER_TITLE: 'Banco Santander',
    GROUP_BANK_MOTORFY_TITLE: 'Motorfy',
    GROUP_BANK_COPPEL_TITLE: 'Coppel',
    GROUP_BANK_ACCOUNT_ADD_BY: 'Cuenta agregada por',
    GROUP_BANK_ACCOUNT_INFO: 'Suba los documentos en JPG o PDF',
    GROUP_CREATE_BANK_ACCOUNT_TITLE: 'Crear nueva cuenta',
    GROUP_CREATE_CARD_COMMISSION_ACCOUNT_TITLE: 'Crear nueva tarjeta',
    GROUP_DEALER_ACCOUNT_STATUS_LABEL: 'Estado de cuenta dealer',
    GROUP_DEALER_OFFICIAL_IDENTIFICATION_LABEL: 'Identificación oficial dealer',
    GROUP_ACCOUNT_TITLE: 'Cuenta',
    GROUP_CARD_COMMISSION_TITLE: 'Tarjeta',
    GROUP_CANCEL_LABEL: 'Cancelar',
    GROUP_SAVE_LABEL: 'Guardar',
    GROUP_DELETE_LABEL: 'Eliminar',
    GROUP_UPDATE_LABEL: 'Actualizar',
    GROUP_CREATE_CARD_COMMISSION_ACT_FILE_TITLE: 'Acta',
    GROUP_CREATE_CARD_COMMISSION_IDENTIFICATION_FILE_TITLE: 'INE',
    GROUP_CREATE_CARD_COMMISSION_IDENTIFICATION_GROUP_FILE_TITLE: 'SELFIE (Dealer)',
    GROUP_CREATE_CARD_COMMISSION_CARD_BACKUP_CODE_FILE_TITLE: 'Código Respaldo Tarjeta',
    GROUP_DELETE_SELECT_REASON: 'Motivos de eliminación',
    GROUP_DELETE_REASON_REASSIGN_CARD: 'Código de la tarjeta a reasignar',
    GROUP_DELETE_REASON_REASSIGN_CARD_ID: 'ReassignCard',
};

export const FILTERS = {
    GROUP_TYPE: 'Tipo de Grupo',
    MARKET_NAMES: 'Mercados',
    EXTERNAL_ADVISERS: 'Asesores externos'
};

export const GROUP_ERROR = {
    GROUP_NAME_ALREADY_EXISTS: 'Ya existe un grupo con ese nombre',
    GROUP_REQUIRED_BANK: 'Debe seleccionar un banco',
    GROUP_INVALID_BANK_ACCOUNT: 'Cuenta inválida o incorrecta',
    GROUP_FIELD_REQUIRED: 'Este campo es obligatorio',
    GROUP_DOCUMENTS_REQUIRED: 'Los documentos a subir son obligatorios'
};

export const GROUP_DEFAULT_STATUS = {
    GROUP_DEFAULT_WARRANTY_PAYMENT_TYPE: {id: 'PREPAID', value: 'Prepago', payload: ''},
    GROUP_DEFAULT_GROUP_TYPE: {id: 'AGENCY_LOT', value: 'Agencia/Distribuidor', payload: ''},
    GROUP_DEFAULT_OPTION_YES_STATUS: true,
    GROUP_DEFAULT_OPTION_NO_STATUS: false
};

export const GROUP_MAX_SIZE_FILE = 10000000;
